import * as Yup from "yup";

const resolveMessage = (message, t) =>
  typeof t === "function" ? t(message) : message;

const mapYupErrors = (error) => {
  if (!error) return {};
  if (Array.isArray(error.inner) && error.inner.length > 0) {
    return error.inner.reduce((acc, item) => {
      const path = item?.path;
      if (!path || acc[path]) return acc;
      acc[path] = item.message;
      return acc;
    }, {});
  }
  if (error.path) {
    return { [error.path]: error.message };
  }
  return {};
};

const buildStepSchema = (step, t) => {
  const message = (text) => resolveMessage(text, t);
  switch (Number(step)) {
    case 1:
      return Yup.object({
        companyName: Yup.string()
          .trim()
          .required(message("Please enter your company name.")),
        country: Yup.string()
          .trim()
          .required(message("Please select a country.")),
      });
    case 2:
      return Yup.object({
        industry: Yup.string()
          .trim()
          .required(message("Please select an industry.")),
      });
    case 3:
      return Yup.object({
        employeesRange: Yup.string()
          .trim()
          .required(message("Please select an employees range.")),
        revenueRange: Yup.string()
          .trim()
          .required(message("Please select a revenue range.")),
      });
    case 4: {
      const stepMessage = message(
        "Add at least one country or objective (optional, you can Skip).",
      );
      return Yup.object({
        serviceCountries: Yup.array(),
        objectives: Yup.array(),
      }).test("step4", stepMessage, (value, ctx) => {
        const hasCountries =
          Array.isArray(value?.serviceCountries) &&
          value.serviceCountries.length > 0;
        const hasObjectives =
          Array.isArray(value?.objectives) && value.objectives.length > 0;
        if (!hasCountries && !hasObjectives) {
          return ctx.createError({ path: "step4", message: stepMessage });
        }
        return true;
      });
    }
    default:
      return null;
  }
};

export const validateCompanyFormStep = (step = 1, form = {}, t) => {
  const schema = buildStepSchema(step, t);
  if (!schema) return {};
  try {
    schema.validateSync(form, { abortEarly: false });
    return {};
  } catch (error) {
    return mapYupErrors(error);
  }
};
